import React, { Component, createRef } from "react";
import classnames from "classnames";
import { v4 as uuidv4 } from "uuid";

class DropDown extends Component {
    constructor(props) {
        super(props);
        // NOTE: label is read from props at render time, not copied into state.
        // It used to be snapshotted here, which meant a label that changes —
        // "Categories" -> "Categories (3)" — could never update.
        this.state = {
            id: uuidv4(),
            open: false
        };
        this.trigger = createRef();
        this.popup = createRef();
    }

    closeDropdownOnWindowClick = event => {
        // If the click happened inside the container, bail. BOTH checks use
        // closest(): a real mouse click lands on inner elements (the label
        // span, the chevron svg), so comparing event.target.id to the
        // trigger's id classified a trigger click as "outside". That
        // misclassification was masked by luck — React's delegated handler
        // runs first (attached at mount, before this one) and removes this
        // listener before it could misfire — but it was one listener-order
        // change away from open-then-close on every trigger click.
        if (
            event.target.closest("#popup-" + this.state.id) ||
            event.target.closest("#trigger-" + this.state.id)
        )
            return;

        // close, not toggle. This used to invert `open`, which happened to be
        // right only because the handler is attached while open — with several
        // dropdowns on the page an outside click could re-open a closed one.
        this.setState({ open: false });

        document.removeEventListener("click", this.closeDropdownOnWindowClick);
    };

    triggerClick = () => {
        // Updater form, and the listener decision rides on the NEW value.
        // The old code branched on this.state.open right after setState —
        // the stale pre-update value — which happened to produce the right
        // add/remove pairing but read exactly backwards.
        this.setState(
            prev => ({ open: !prev.open }),
            () => {
                if (this.state.open) {
                    // Listen for all clicks on the document
                    document.addEventListener(
                        "click",
                        this.closeDropdownOnWindowClick,
                        false
                    );
                } else {
                    document.removeEventListener(
                        "click",
                        this.closeDropdownOnWindowClick
                    );
                }
            }
        );
    };

    render() {
        const { open } = this.state;

        return (
            <div className="il-drop-down-container position-relative">
                <button
                    id={"trigger-" + this.state.id}
                    ref={this.trigger}
                    onClick={this.triggerClick}
                    aria-haspopup="true"
                    aria-expanded={this.state.open}
                    className="d-flex align-items-end mr-2 il-btn-trigger btn btn-sm btn-outline-secondary dropdown-toggle border-0"
                >
                    <span className="il-drop-down-label">{this.props.label}</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        className="il-dropdown-icon ml-2"
                    >
                        <path
                            fill="currentColor"
                            d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                        />
                    </svg>
                </button>
                <div
                    id={"popup-" + this.state.id}
                    ref={this.popup}
                    role="menu"
                    className={classnames(
                        open ? "show" : "d-none",
                        "il-pop-over popover bs-popover-bottom shadow-sm"
                    )}
                    aria-labelledby={"trigger-" + this.state.id}
                >
                    <div className="arrow"></div>
                    <div className="popover-body">{this.props.children}</div>
                </div>
            </div>
        );
    }
}

export default DropDown;
